<div class="container-fluid py-4 bg-lightblue contact-us-contact-center">
    <div class="container-xxxl py-lg-4">
        <div class="row">
            <!-- Full-width section heading -->
            <div class="col-12">
                <div class="container-fluid pb-32">
                    <div class="row">
                        <h2 class="section-heading text-blue border-blue">{{ mainTitle }}</h2>
                    </div>
                </div>
            </div>

            <!-- Main intro body -->
            <div class="col-12 col-lg-6 pe-lg-5">
                <clamper class="d-block" [maxLines]="mainBodyMaxLines" [text]="mainBody"></clamper>
            </div>

            <!-- Separator above the two top cards -->
            <hr class="col-12 d-lg-none my-5" />

            <!-- Right-side content -->
            <div class="col-12 col-lg-6 ps-lg-5">
                <!-- Form contact section -->
                <div class="mb-4">
                    <h5 class="text-blue fs-18 fs-md-22 mb-0">
                        {{ formTitle }}
                    </h5>
                </div>

                <div class="mb-4" [innerHTML]="formBody"></div>

                <a class="btn btn-green btn-arrow text-white blue-effect px-4" [href]="buttonUrl" target="_blank" [attr.aria-label]="buttonTitle + ' (opens in a new tab)'">
                    {{ buttonTitle }}
                    <i class="icon-gard-arrow-right ms-1"></i>
                </a>

                <!-- Separator above submit your organization section -->
                <hr class="col-12 my-5" />

                <div class="col-12 pb-4">
                    <div class="mb-4">
                        <h5 class="text-blue fs-18 fs-md-22 mb-0">
                            {{ requestFormTitle }}
                        </h5>
                    </div>

                    <div class="mb-4" [innerHTML]="requestFormBody"></div>

                    <div>
                        <a
                            class="btn btn-green btn-arrow text-white blue-effect px-4"
                            [href]="requestButtonUrl"
                            target="_blank"
                            [attr.aria-label]="requestButtonTitle + ' (opens in a new tab)'"
                        >
                            {{ requestButtonTitle }}
                            <i class="icon-gard-arrow-right ms-1"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
